export const mockProgramReports = [
  {
    id: 1,
    name: '2024-HousingProduction-HOME-ActivityReport-1',
    description: '2024 CDGA Project Activity Report',
    createdAt: '11/31/2024',
    fileUrl: '/2024-HousingProduction-HOME-ActivityReport-1.pdf',
    projectId: '647',
  },
  {
    id: 2,
    name: '2024BLANKACTIVITYFORM-3',
    description: 'HOMEBUYER COUNSELING PROGRAM',
    createdAt: '11/09/2024',
    fileUrl: '/2024BLANKACTIVITYFORM-3.pdf',
    projectId: '648',
  },
  {
    id: 3,
    name: '2023BLANKACTIVITYFORM',
    description: 'HOMEBUYER COUNSELING PROGRAM',
    createdAt: '05/08/2023',
    fileUrl: '/2024BLANKACTIVITYFORM-3.pdf',
  },
];
